// ABOUTME: Analytics event tracking functions for PostHog and Google Ads.
// ABOUTME: All posthog.capture() and gtag() calls in the app go through this file.
import posthog from 'posthog-js'

declare global {
  interface Window {
    gtag?: (command: string, action: string, params?: Record<string, unknown>) => void
  }
}

const GOOGLE_ADS_CONVERSION_GAME_CREATED = 'AW-18130844258/pBZpCPmPjaYcEOL0usVD'
const GOOGLE_ADS_CONVERSION_SIGNUP = 'AW-18130844258/GfLKCM-Yg60cEOL0usVD'
const GOOGLE_ADS_CONVERSION_GAME_FINISHED = 'AW-18130844258/00clCMfIn60cEOL0usVD'

function sendGoogleAdsConversion(conversionId: string): void {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', { send_to: conversionId })
  }
}

export function trackLandingPageViewed(): void {
  posthog.capture('landing_page_viewed')
}

export function trackSignupCompleted(userId: string): void {
  posthog.capture('signup_completed', { user_id: userId })
  sendGoogleAdsConversion(GOOGLE_ADS_CONVERSION_SIGNUP)
}

export function trackGameCreated(gameId: string): void {
  posthog.capture('game_created', { game_id: gameId })
  sendGoogleAdsConversion(GOOGLE_ADS_CONVERSION_GAME_CREATED)
}

export function trackPlayerAdded(gameId: string, playerCount: number): void {
  posthog.capture('player_added', { game_id: gameId, player_count: playerCount })
}

export function trackGameFinished(gameId: string): void {
  posthog.capture('game_finished', { game_id: gameId })
  sendGoogleAdsConversion(GOOGLE_ADS_CONVERSION_GAME_FINISHED)
}

export function trackGameJoined(gameId: string): void {
  posthog.capture('game_joined', { game_id: gameId })
}

export function trackGameFinishedAsPlayer(gameId: string): void {
  posthog.capture('game_finished_as_player', { game_id: gameId })
  sendGoogleAdsConversion(GOOGLE_ADS_CONVERSION_GAME_FINISHED)
}

export function trackShareLinkCopied(source: 'game' | 'square_pack', id: string): void {
  posthog.capture('share_link_copied', { source, id })
}

export function trackJoinPageViewed(gameId: string): void {
  posthog.capture('join_page_viewed', { game_id: gameId })
}
